import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "wws_cookie_consent_v1";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (_) {
      // localStorage unavailable — just show the banner
      setVisible(true);
    }
  }, []);

  const dismiss = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    } catch (_) {
      // ignore
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60]"
          role="dialog"
          aria-live="polite"
          aria-label="Cookie notice"
          data-testid="cookie-consent"
        >
          <div className="glass border border-[#262626] bg-[#0A0A0A]/95 backdrop-blur-xl p-5 md:p-6 shadow-2xl">
            <div className="flex items-start justify-between gap-4 mb-3">
              <h4 className="font-['Oswald'] text-white uppercase tracking-wider text-base">
                Cookies
              </h4>
              <button
                onClick={() => dismiss("dismissed")}
                className="text-[#666] hover:text-white transition-colors -mt-1 -mr-1"
                aria-label="Close cookie notice"
                data-testid="cookie-close-button"
              >
                <X size={16} />
              </button>
            </div>
            <p className="font-['Manrope'] text-[#AAAAAA] text-sm leading-relaxed mb-5">
              This site uses only strictly necessary cookies to work properly &mdash; no tracking, no ads.
              See the{" "}
              <Link to="/privacy" className="text-[#FF4500] hover:underline">
                Privacy Policy
              </Link>{" "}
              for details.
            </p>
            <div className="flex items-center gap-3">
              <button
                onClick={() => dismiss("accepted")}
                className="btn-primary rounded-none font-['Oswald'] uppercase tracking-wider text-sm px-5 py-2.5"
                data-testid="cookie-accept-button"
              >
                Got it
              </button>
              <Link
                to="/privacy"
                className="font-['Manrope'] text-[#888] hover:text-white text-sm transition-colors"
                data-testid="cookie-learn-more-link"
              >
                Learn more
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
